<div class="register-container">
  <div class="background">
    <div class="gradient-overlay"></div>
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>
  </div>

  <div class="register-panel">
    <div class="register-panel-left">
      <div class="brand-logo">
        <svg viewBox="0 0 24 24" class="logo-icon">
          <path
            d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
          ></path>
        </svg>
        <span class="logo-text">Markado</span>
      </div>
      <div class="illustration">
        <div class="illustration-circle"></div>
        <div class="illustration-shape shape-1"></div>
        <div class="illustration-shape shape-2"></div>
        <div class="illustration-shape shape-3"></div>
      </div>
      <div class="welcome-text">
        <h1>Join Us</h1>
        <p>Create an account to access our platform</p>
      </div>
    </div>

    <div class="register-panel-right">
      <div class="register-header">
        <h2>Create Account</h2>
        <p>Fill in your details to get started</p>
      </div>

      <form
        [formGroup]="registerForm"
        (ngSubmit)="onSubmit()"
        class="register-form"
      >
        <div class="form-row">
          <div
            class="form-group"
            [class.form-error]="
              first_name?.invalid && (first_name?.dirty || first_name?.touched)
            "
          >
            <label for="first_name">First Name</label>
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                ></path>
              </svg>
              <input
                type="text"
                id="first_name"
                formControlName="first_name"
                placeholder="John"
                [class.is-invalid]="
                  first_name?.invalid &&
                  (first_name?.dirty || first_name?.touched)
                "
              />
            </div>
            <div
              class="error-text"
              *ngIf="
                first_name?.invalid &&
                (first_name?.dirty || first_name?.touched)
              "
            >
              <div *ngIf="first_name?.errors?.['required']">
                First name is required
              </div>
            </div>
          </div>

          <div
            class="form-group"
            [class.form-error]="
              last_name?.invalid && (last_name?.dirty || last_name?.touched)
            "
          >
            <label for="last_name">Last Name</label>
            <div class="input-wrapper">
              <svg class="input-icon" viewBox="0 0 24 24">
                <path
                  d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                ></path>
              </svg>
              <input
                type="text"
                id="last_name"
                formControlName="last_name"
                placeholder="Doe"
                [class.is-invalid]="
                  last_name?.invalid && (last_name?.dirty || last_name?.touched)
                "
              />
            </div>
            <div
              class="error-text"
              *ngIf="
                last_name?.invalid && (last_name?.dirty || last_name?.touched)
              "
            >
              <div *ngIf="last_name?.errors?.['required']">
                Last name is required
              </div>
            </div>
          </div>
        </div>

        <div
          class="form-group"
          [class.form-error]="
            email?.invalid && (email?.dirty || email?.touched)
          "
        >
          <label for="email">Email</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              ></path>
            </svg>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="you@example.com"
              [class.is-invalid]="
                email?.invalid && (email?.dirty || email?.touched)
              "
            />
          </div>
          <div
            class="error-text"
            *ngIf="email?.invalid && (email?.dirty || email?.touched)"
          >
            <div *ngIf="email?.errors?.['required']">Email is required</div>
            <div *ngIf="email?.errors?.['email']">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <div
          class="form-group"
          [class.form-error]="
            password?.invalid && (password?.dirty || password?.touched)
          "
        >
          <label for="password">Password</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
              ></path>
            </svg>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              placeholder="••••••••"
              [class.is-invalid]="
                password?.invalid && (password?.dirty || password?.touched)
              "
            />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              tabindex="-1"
              aria-label="Toggle password visibility"
            >
              <svg class="eye-icon" viewBox="0 0 24 24" *ngIf="!showPassword">
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <circle cx="12" cy="10" r="2"></circle>
              </svg>
              <svg class="eye-icon" viewBox="0 0 24 24" *ngIf="showPassword">
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <line
                  x1="4"
                  y1="4"
                  x2="20"
                  y2="20"
                  stroke="currentColor"
                  stroke-width="2"
                ></line>
              </svg>
            </button>
          </div>
          <div
            class="error-text"
            *ngIf="password?.invalid && (password?.dirty || password?.touched)"
          >
            <div *ngIf="password?.errors?.['required']">
              Password is required
            </div>
            <div
              *ngIf="password?.errors?.['minlength'] || password?.errors?.['uppercase'] || password?.errors?.['number'] || password?.errors?.['specialChar']"
            >
              Password must be at least 8 characters and include an uppercase
              letter, a number, and a special character
            </div>
          </div>

          <div
            class="password-strength-container"
            *ngIf="password?.value?.length > 0"
          >
            <div
              class="password-strength"
              [style.--strength]="calculateStrengthPercentage()"
              [style.background-color]="getStrengthColor()"
            ></div>
            <div class="password-strength-text">
              <span>Weak</span>
              <span>{{ getStrengthLabel() }}</span>
              <span>Strong</span>
            </div>
          </div>
        </div>

        <div
          class="form-group"
          [class.form-error]="
            (confirm_password?.invalid ||
              registerForm.hasError('passwordMismatch')) &&
            (confirm_password?.dirty || confirm_password?.touched)
          "
        >
          <label for="confirm_password">Confirm Password</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
              ></path>
            </svg>
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              id="confirm_password"
              formControlName="confirm_password"
              placeholder="••••••••"
              [class.is-invalid]="
                (confirm_password?.invalid ||
                  registerForm.hasError('passwordMismatch')) &&
                (confirm_password?.dirty || confirm_password?.touched)
              "
            />
            <button
              type="button"
              class="toggle-password"
              (click)="toggleConfirmPasswordVisibility()"
              tabindex="-1"
              aria-label="Toggle confirm password visibility"
            >
              <svg
                class="eye-icon"
                viewBox="0 0 24 24"
                *ngIf="!showConfirmPassword"
              >
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <circle cx="12" cy="10" r="2"></circle>
              </svg>
              <svg
                class="eye-icon"
                viewBox="0 0 24 24"
                *ngIf="showConfirmPassword"
              >
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <line
                  x1="4"
                  y1="4"
                  x2="20"
                  y2="20"
                  stroke="currentColor"
                  stroke-width="2"
                ></line>
              </svg>
            </button>
          </div>
          <div
            class="error-text"
            *ngIf="
              (confirm_password?.invalid ||
                registerForm.hasError('passwordMismatch')) &&
              (confirm_password?.dirty || confirm_password?.touched)
            "
          >
            <div *ngIf="confirm_password?.errors?.['required']">
              Please confirm your password
            </div>
            <div
              *ngIf="confirm_password?.errors?.['passwordMismatch'] || registerForm.hasError('passwordMismatch')"
            >
              Passwords do not match
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="phone_number">Phone Number (Optional)</label>
          <div class="phone-input-wrapper">
            <div class="country-code-dropdown">
              <select
                id="country_code"
                formControlName="country_code"
                class="country-select"
                aria-label="Country code"
              >
                <option
                  *ngFor="let country of countryCodes"
                  [value]="country.dialCode"
                >
                  {{ country.code }} {{ country.dialCode }}
                </option>
              </select>
              <div class="dropdown-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
            </div>

            <div class="phone-input">
              <input
                type="tel"
                id="phone_number"
                formControlName="phone_number"
                placeholder="Phone number"
                class="phone-number-input"
                [class.is-invalid]="
                  phone_number?.invalid &&
                  (phone_number?.dirty || phone_number?.touched)
                "
              />
            </div>
          </div>
          <div
            class="error-text"
            *ngIf="
              phone_number?.invalid &&
              (phone_number?.dirty || phone_number?.touched)
            "
          >
            <div *ngIf="phone_number?.errors?.['pattern']">
              Please enter digits only (no spaces, dashes or other characters)
            </div>
            <div *ngIf="phone_number?.errors?.['invalidNumber']">
              Invalid phone number format for {{ selectedCountry?.name }}
            </div>
          </div>
          <div class="phone-help-text">
            <small> Example: {{ getPhoneExampleNumber() }} </small>
          </div>
        </div>

        <div class="form-group">
          <div class="marketing-consent-wrapper">
            <label class="checkbox-container" for="marketing_consent">
              <input
                type="checkbox"
                id="marketing_consent"
                formControlName="marketing_consent"
                class="checkbox-input"
              />
              <span class="checkmark"></span>
              <span class="checkbox-text">
                I would like to receive marketing emails, newsletters, and
                promotional offers from Markado
              </span>
            </label>
          </div>
        </div>

        <div class="form-group">
          <app-recaptcha
            (tokenChange)="onRecaptchaChange($event)"
            (error)="onRecaptchaError($event)"
            [errorMessage]="recaptchaErrorMessage"
          >
          </app-recaptcha>
        </div>

        <div class="alert alert-error" *ngIf="errorMessage">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>

        <div *ngIf="successMessage" class="success-overlay">
          <div class="success-modal">
            <div class="success-icon-container">
              <svg class="success-icon" viewBox="0 0 24 24">
                <path
                  class="success-icon-circle"
                  d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z"
                ></path>
                <path
                  class="success-icon-check"
                  d="M7.8,13.2l2.8,2.8l5.6-5.6"
                ></path>
              </svg>
            </div>
            <h3 class="success-title">Success!</h3>
            <p class="success-message">{{ successMessage }}</p>
            <div class="success-progress">
              <div class="success-progress-bar"></div>
            </div>
          </div>
        </div>

        <button
          type="submit"
          class="signin-button"
          [disabled]="isSubmitting || registerForm.invalid || !recaptchaToken"
        >
          <span *ngIf="!isSubmitting">Create Account</span>
          <div class="spinner" *ngIf="isSubmitting">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>

        <div class="signup-prompt">
          <span>Already have an account?</span>
          <a routerLink="/login" class="signup-link">Sign In</a>
        </div>
      </form>
    </div>
  </div>
</div>
